<template>
<!-- eslint-disable -->
   <div class="module-wrap module-analyuze" :analyzeData="analyzeData">
     <h2 v-html="moduleTitle"></h2>
     <div class="analyze-wrap">
       <div class="tip">
         <p>我的用时</p>
         <p>建议用时</p>
       </div>
       <div class="table-explain">
         <span>难度说明：</span>
         <i class="easy">易</i>
         <i class="moddle">中</i>
         <i class="hard">难</i>
       </div>
       <div class="table">
         <template>
           <el-table
             v-if="isHasTable"
             :data="tableData"
             border
             :header-cell-style="heatStyle"
             :cell-style="cellStyle"
             :align="center"
             :span-method="objectSpanMethod"
             style="width: 100%;border: 2px solid #3CC7FF ; border-radius: 4px;">
             <el-table-column
               v-if="hasTagName1"
               prop="tag_name1"
               label="一级知识点"
               width="130"
               align="center"
               >
             </el-table-column>
             <el-table-column
               prop="tag_name2"
               label="纳米知识点"
               width="180"
               center
              align="center"
               >
             </el-table-column>
             <el-table-column
               label="掌握程度"
               width="150"
               align="center"

               >
                  <template slot-scope="scope">
                 <div :class="['size',ability_color(scope.row.final_ability)]">
                   <!-- <p v-if="scope.row.is_mastery == 0" style="text-align:center">未掌握</p> -->
                  <!-- <p v-else  style="text-align:center;">掌握</p> -->
                  <p style="text-align:center;">{{abilityArt(scope.row.final_ability)}}</p>
                  <p class="zw-ability">({{((scope.row.final_ability*100).toFixed(0))}}%)</p>
                 </div>
               </template>
             </el-table-column>
             <el-table-column
               prop="tag_name1"
               label="难度"
               width="110"
               align="center"
               >
               <template slot-scope="scope">
                 <div class="diff-wrap">
                   <div class="diff diff-no" v-if="scope.row.difficulty==0">
                     ---
                   </div>
                   <div class="diff" v-else>
                     <!--<div  v-for="(item, i) in scope.row.difficulty"-->
                          <!--:key="i" class="diff-succ"-->
                          <!--:style="{opacity:+1-`${i}`/10}">-->
                     <!--</div>-->
                     <div class="diff-def">
                       <i v-for="(item, i) in 9"></i>
                     </div>
                     <div v-if="0<Number(scope.row.difficulty) && Number(scope.row.difficulty)<=3">
                       <div v-for="(item, i) in Number(scope.row.difficulty)"
                            :key="i" class="easy">
                       </div>
                     </div>
                     <div v-else-if="4<=Number(scope.row.difficulty) && Number(scope.row.difficulty)<=6">
                       <div v-for="(item2, i) in Number(scope.row.difficulty)"
                            :key="i" class="moddle">
                       </div>
                     </div>
                     <div  v-else-if="7<=Number(scope.row.difficulty) && Number(scope.row.difficulty)<=9">
                       <div v-for="(item3, i) in Number(scope.row.difficulty)"
                            :key="i" class="hard">
                       </div>
                     </div>
                     <!--<div  v-for="(item2, k) in (maxDifficulty-scope.row.difficulty)"-->
                           <!--:track-ty='k'-->
                          <!--class="default-diff">-->
                     <!--</div>-->
                   </div>
                 </div>
               </template>
             </el-table-column>
             <el-table-column
               label="答题时间" 
               align="center">
               <template slot-scope="scope">
                 <p class="font14" v-if="scope.row.do_question_time=='-' && scope.row.advise_time =='-'">
                   <span >由算法推测，未作答</span>
                 </p>
                 <div v-else>
                   <p class="ustime-wrap">
                     <el-progress
                       class="ustime do-qus-time"
                       v-if="scope.row.do_question_time!='-'"
                       :percentage="scope.row.do_question_time/scope.row.advise_time*100>100?88.23:scope.row.do_question_time/scope.row.advise_time*100"
                       :show-text="false" color="#00B1FF" :stroke-width='12'
                     />
                     <el-progress
                       class="ustime do-qus-time"
                       v-else
                       :percentage="0"
                       :show-text="false" color="#00B1FF" :stroke-width='12'
                     />
                     <span v-if="scope.row.do_question_time!='-'">{{getPercentTime(scope.row.do_question_time)}}</span>
                     <span v-else class="no-time">---</span>
                   </p>
                   <p class="ustime-wrap" v-if="scope.row.advise_time =='-'">
                     <el-progress
                       class="ustime"
                       :percentage="0" :stroke-width='12'
                       :show-text="false" color="#FF9A42"
                     />
                     <span class="no-time">---</span>
                   </p>
                   <p class="ustime-wrap" v-else>
                     <el-progress
                       class="ustime advise-time"
                       v-if="isHasTable"
                       :percentage="88.23" :stroke-width='12'
                       :show-text="false" color="#FF9A42"
                     />
                     <span>{{scope.row.advise_time?getPercentTime(scope.row.advise_time): '---'}}</span>
                   </p>
                 </div>
               </template>
             </el-table-column>
           </el-table>
         </template>
       </div>
     </div>
   </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'ModuleKnowlegeAnalyze',
  props: ['moduleTitle', 'analyzeData'],
  // props: {
  //   moduleTitle: {
  //     type: String
  //   },
  //   analyzeData: {
  //     type: Array,
  //     default:  function(){
  //       return {
  //       }
  //     }
  //   }
  // },
  data() {
    return {
      tableData: [],
      maxDifficulty: 9,
      diffDefalt: 1,
      diffClass: '',
      isHasTable: false,
      isMastery: 0,
      rowIndex: '-1',
      OrderIndexArr: [],
      hoverOrderArr: [],
      spanArr: [],
      position: [],
      center: '',
      percentage: '',
      usTimeLine: {
        start: '#00B1FF',
        end: '#4E74FF',
      },
      overtimeLine: '#FF9A42',
      heatStyle: {
        border: '0',
        color: '#fff',
        backgroundImage: 'linear-gradient(90deg, #00B1FF, #4E74FF)',
      },
      cellStyle: {
        fontSize: '16px',
        color: '#666',
        borderBottom: 'dashed 1px #00B1FF',
        borderRight: 'dashed 1px #00B1FF',
        textAlign: 'center',
      },
      hasTagName1: true, // tag_name1 为空时不展示
    };
  },
  components: {
    // timeProgress, // 时间进度条
  },
  mounted() {
    // this.initData()
  },
  computed: {
    // {
    //   let that = this, myclass= ''
    //   this.tableData.forEach((item, index) => {
    //     if(0<item.difficulty && item.difficulty<=3){
    //       myclass = 'easy'
    //       return myclass
    //     }else if(4<=item.difficulty && item.difficulty<=6){
    //       myclass = 'moddle'
    //       return myclass
    //     }else{
    //       myclass = 'hard'
    //       return myclass
    //     }
    //   })
    // },
    relativeStrokeWidth() {
      this.tableData.forEach((item, index) => ({
        opacity: item.difficulty,
      }));
    },
    perimeter() {
      const radius = 50 - parseFloat(this.relativeStrokeWidth) / 2;
      return 2 * Math.PI * radius;
    },
  },
  watch: {
    // analyzeData () {
    //   this.initData()
    // }
  },
  methods: {
    renderAnalyzeResult() {
      this.isHasTable = true;
      this.tableData = this.analyzeData;
      this.tableData.forEach((item, index) => {
        if (!item.tag_name1) {
          this.hasTagName1 = false;
        } else {
          this.hasTagName1 = true;
        }
      });
      if (this.hasTagName1) {
        this.getOrderNumber();
      }
    },
        ability_color(data){
      if (0<=data&&data<=0.2) {
        // this.ailityArt='未掌握'
        return 'one'
      }
      if (0.2<data&&data<=0.4) {
        // this.ailityArt='掌握较弱'
        return 'two'
      }
      if (0.4<data&&data<=0.6) {
        // this.ailityArt='掌握一般'
        return 'three'
      }
      if (0.6<data&&data<=0.8) {
        // this.ailityArt='掌握较好'
        return 'four'
      }
      if (0.8<data&&data<=1) {
        // this.ailityArt='掌握熟练'
        return 'five'
      }
    },
    abilityArt(data){
      if (0<=data&&data<=0.2) {
        return '未掌握'
      }
      if (0.2<data&&data<=0.4) {
        return '掌握较弱'
      }
      if (0.4<data&&data<=0.6) {
        return '掌握一般'
      }
      if (0.6<data&&data<=0.8) {
        return '掌握较好'
      }
      if (0.8<data&&data<=1) {
        return '掌握熟练'
      }
    },
    // initData: async function () {
    //   let that = this
    //   let res = await this.analyzeData
    //   if (res) {
    //     this.tableData = res
    //     console.log(res) // 是一个数组
    //   }
    // },
    getPercentTime(time) {
      const m = Math.floor(time / 60);
      const s = time - m * 60;
      return `${m}分${s}秒`;
    },
    getOrderNumber() {
      const OrderObj = {};
      console.log(this.tableData.sort(this.compare('tag_name1')));
      this.tableData.forEach((element, index) => {
        element.rowIndex = index;
        if (OrderObj[element.tag_name1]) {
          OrderObj[element.tag_name1].push(index);
        } else {
          OrderObj[element.tag_name1] = [];
          OrderObj[element.tag_name1].push(index);
        }
      });
      console.log(this.OrderIndexArr);
      // 将数组长度大于1的值 存储到this.OrderIndexArr（也就是需要合并的项）
      for (const k in OrderObj) {
        if (OrderObj[k].length > 1) {
          this.OrderIndexArr.push(OrderObj[k]);
        }
      }
      this.tableData = JSON.parse(JSON.stringify(this.tableData.sort(this.compare('tag_name1'))));
    },
    // 定义一个函数
    compare(pro) {
      return function (obj1, obj2) {
        const val1 = obj1[pro];
        const val2 = obj2[pro];
        if (val1 < val2) { // 正序
          return 1;
        } if (val1 > val2) {
          return -1;
        }
        return 0;
      };
    },
    objectSpanMethod({
      row, column, rowIndex, columnIndex,
    }) {
      if (columnIndex === 0) {
        for (let i = 0; i < this.OrderIndexArr.length; i++) {
          const element = this.OrderIndexArr[i];
          for (let j = 0; j < element.length; j++) {
            const item = element[j];
            if (rowIndex == item) {
              if (j == 0) {
                return {
                  rowspan: element.length,
                  colspan: 1,
                };
              } if (j != 0) {
                return {
                  rowspan: 0,
                  colspan: 0,
                };
              }
            }
          }
        }
      }
    },
    objectSpanMethodFinal({
      row, column, rowIndex, columnIndex,
    }) {
      if (columnIndex === 0) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1,
          };
        }
        return {
          rowspan: 0,
          colspan: 0,
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h2 {
  width: 358px;
  height: 40px;
  margin: 58px auto 32px auto;
  font-size: 20px;
  line-height: 40px;
  text-align: center;
  background: url("~@/assets/img/sub_headbg.png") no-repeat;
  background-size: cover;
}
.analyze-wrap{
  width: 666px;
  margin: 0 auto;
  .ustime-wrap{
    display: flex;
    align-items: center;
    .no-time{
      font-family: Helvetica;
      font-size: 16px;
      color: #CCC;
      line-height: 16px;
    }
    .ustime{
      display: flex;
      width: 68px;
      flex: 0 0 auto;
      margin-right: 2px;
      .el-progress-bar{
        margin-right: 0;
        padding-right: 0;
        .el-progress-bar__outer{
          padding-right: 4px;
          box-sizing: border-box;
        }
        .el-progress-bar__inner{
          margin: 3px 4px;
          height: 6px;
        }
      }
    }
    .do-qus-time{
      .el-progress-bar__inner{
        background:linear-gradient(270deg,rgba(0,177,255,1) 0%,rgba(78,116,255,1) 100%)!important;
      }
    }
    .advise-time{
      .el-progress-bar__inner {
        background: linear-gradient(270deg, rgba(255, 208, 80, 1) 0%, rgba(255, 154, 66, 1) 100%) !important;
      }
    }
  }
  .tip{
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #666;
    letter-spacing: 0;
    text-align: center;
    line-height: 14px;
    margin-bottom: 32px;
    p{
    position: relative;
      padding-left:25px;
      margin-left: 25px;
    }
    :before{
      position: absolute;
      content: "";
      left: 0;
      width: 14px;
      height: 14px;
      border-radius: 50%;
    }
    p:first-child:before{
        background: #00B1FF ;
    }
    p:last-child:before{
        background: #FF9A42 ;
    }
  }
  .table-explain{
    margin-bottom: 13px;
    font-size:14px;
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:14px;
    i{
      display: inline-block;
      position: relative;
      padding-left: 14px;
      margin-right: 40px;
    }
    i:before{
      position: absolute;
      left: 0;
      top: -3px;
      content: "";
      width:6px;
      height:20px;
      border-radius:3px;
    }
    i.easy:before{
      background:rgba(27,219,143,1);
    }
    i.moddle:before{
      background:rgba(22,214,226,1);
    }
    i.hard:before{
      background:rgba(244,214,6,1);
    }
  }
  .table{
    .has-zw{
      color: #00B1FF;
    }
    .no-zw{
      color: #FF586F;
    }
  }
  .el-table th, .el-table tr{
    background-color: transparent;
  }
  .el-table thead tr{
    background-color: transparent!important;
    background-image: linear-gradient(-90deg, #4E74FF 0%, #00B1FF 100%)!important;
  }
  .el-table th{
    text-align: center;
    background-image: none!important;
  }
  .el-table--border::after, .el-table--group::after{
    width: 0!important;
  }
  /deep/.el-progress-bar__inner{
    margin: 3px 4px;
    height: 6px;
  }
  .diff-wrap{
    position: relative;
    height: 24px;
    .diff{
      position: absolute;
      height: 24px;
      left: 8px;
      width: 100%;
      text-align: center;
      .diff-def{
        position: absolute;
        z-index: 0;
        i{
          display: inline-block;
          margin-left: 2px;
          width: 6px;
          height: 24px;
          background-color: #D8D8D8;
          border-radius: 6px;
        }
      }
      div{
        position: relative;
        z-index: 3;
        height: 24px;
        /*float: left;*/
        /*margin-left: 2px;*/
        /*width: 6px;*/
        /*height: 24px;*/
        /*background-color: #D8D8D8;*/
        /*border-radius: 6px;*/
        div{
          float: left;
          margin-left: 2px;
          width: 6px;
          height: 24px;
          border-radius: 6px;
        }
        .easy{
          background:rgba(27,219,143,1);
        }
        .moddle{
          background:rgba(22,214,226,1);
        }
        .hard{
          background:rgba(244,214,6,1);
        }
      }
      .diff-succ{
        background:linear-gradient(270deg,rgba(0,177,255,1) 0%,rgba(78,116,255,1) 100%);
      }
    }
    .diff-no{
      margin-left: -10px;
    }
  }
  .size{
    font-size: 16px;
  }
  .one{
      color: #FB602D;
    }
    .two{
      color: #FF9F00;
    }
    .three{
      color: #FFCC0C;
    }
    .four{
      color: #0089FF;
    }
    .five{
      color: #00B853;
    }
}
</style>
